import { GotoPageHandlerInterface } from 'src/providers/pushnotification-service/pushnotification-handler';
import { NavController } from '@ionic/angular';
import { AbstractNotificationHandlerPage } from 'src/providers/pushnotification-service/notification-handler-constructs';
import * as global from 'src/globals';
//import {FriendListPage} from './friend-list/friend-list';
import { CompetitionDetailsPage } from './competition/competition-details/competition-details.page';
import { CompetitionFlightsPage } from './competition/competition-flights/competition-flights.page';
import { NavigationExtras, Router } from '@angular/router';


/**
 * Created by ashok on 20/03/17.
 */

export class MygolfGotoPageHandler implements GotoPageHandlerInterface {
    navigationExtras: NavigationExtras = {};
    private router: Router
    gotoPage(nav: NavController, type: string, data: any, needRefresh: boolean) {
        //     
        if (type === AbstractNotificationHandlerPage.TYPE_COMP_ROUND_STARTED) {
            global.SharedObject.homeInfo.needRefresh = true;
            // this.nav.popToRoot();
            // nav.popToRoot();
            this.router.navigate(['tabs/player-home']);
        }
        else if (type === AbstractNotificationHandlerPage.TYPE_COMP_INFO_CHANGED) {
            let compId = data.competitionDetailChanged;
            // nav.push(CompetitionDetailsPage,{
            //     competitionId: compId
            // });
            this.navigationExtras.state = {
                competitionId: compId
            }
            this.router.navigate(['tabs/competition-details'], this.navigationExtras);
        }
        else if (type === AbstractNotificationHandlerPage.TYPE_FLIGHTS_GENERATED) {
            let compId = data.competitionId;
            let roundNo = data.roundNo;
            //    
            // nav.push(CompetitionFlightsPage,{
            //     competitionId: compId,
            //     roundNo: roundNo
            // });
            this.navigationExtras.state = {
                competitionId: compId,
                roundNo: roundNo
            }
            this.router.navigate(['tabs/competition-flights'], this.navigationExtras);
        }
        else if (type === AbstractNotificationHandlerPage.TYPE_FRIEND_REQUEST) {
            // nav.push(FriendListPage,{
            //     homeInfo: global.SharedObject.homeInfo
            // });
            this.navigationExtras.state = {
                homeInfo: global.SharedObject.homeInfo
            }
            this.router.navigate(['/tabs/friend-list'], this.navigationExtras);
        }
        else if (type === AbstractNotificationHandlerPage.TYPE_FRIEND_REQUEST_ACCEPTED) {
            // nav.push(FriendListPage,{
            //     homeInfo: global.SharedObject.homeInfo
            // });
            this.navigationExtras.state = {
                homeInfo: global.SharedObject.homeInfo
            }
            this.router.navigate(['/tabs/friend-list'], this.navigationExtras);
        }
    }

}